export default {
  首页: "Начало",
  资产: "Активи",
  币币: "Спот",
  快捷买币: "Бързо купуване на криптовалута",
  "支持多种方式购买，购买更简单":
    "Купувайте лесно с множество начини на плащане",
  语言设置: "Езикови настройки",
  确认恢复: "Потвърждаване на възстановяването",
  "输入邮箱，方便我们联系您":
    "Въведете имейла си, за да можем да се свържем с вас",
  划转: "Прехвърляне",
  行情: "Пазар",
  "24H成交": "Обем 24ч",
  累计收益: "Обща доходност",
  充值时间: "Дата на депозиране",
  到期时间: "Дата на изтичане",
  数量: "Количество",
  操作: "Действие",
  资产信息: "Информация за активите",
  复制地址: "Копиране на адрес",
  链名称: "Име на верига",
  充值地址: "Адрес за депозиране",
  收款地址: "Адрес за получаване",
  账单: "Фактура",
  提现金额: "Сума за теглене",
  接收地址: "Адрес за получаване",
  交易密码: "Парола за търговия",
  提现全部: "Изтегли всичко",
  保存图片: "Запазване на изображение",
  输入您的交易密码: "Въведете паролата си за търговия",
  确定: "Потвърди",
  地址: "Адрес",
  注册时间: "Дата на регистрация",
  取消: "Отказ",
  是否划转: "Прехвърляне?",
  登录: "Вход",
  我的地址: "Моите адреси",
  登录密码和交易密码: "Парола за вход и парола за търговия",
  注册: "Регистрация",
  密码: "Парола",
  设置密码: "Задаване на парола",
  重复密码: "Повторение на паролата",
  新密码: "Нова парола",
  确认新密码: "Потвърждаване на нова парола",
  充值: "Депозиране",
  充值货币: "Депозиране на валута",
  合约账户充值: "Депозиране в сметка за фючърси",
  账户充值: "Депозиране в сметка",
  其他: "Други",
  我的邀请码: "Моят код за покана",
  提现: "Теглене",
  客服: "Обслужване на клиенти",
  持有详情: "Детайли на притежанието",
  请输入内容: "Въведете съдържание",
  邀请好友来领取奖励: "Поканете приятели и получете награди",
  复制链接: "Копиране на линк",
  重复设置新的密码: "Повторение на новата парола",
  保存: "Запазване",
  我的: "Моят профил",
  "邮箱/手机号": "Имейл/Телефонен номер",
  备注: "Забележка",
  地址管理: "Управление на адреси",
  我的团队: "Моят екип",
  联系我们: "Свържете се с нас",
  竭诚为您服务: "Ние сме на ваше разположение",
  提取收益: "Изтегляне на доходност",
  带给我的收益: "Генерирана доходност",
  添加: "Добавяне",
  名称: "Име",
  添加地址: "Добавяне на адрес",
  修改地址: "Промяна на адрес",
  可提现: "Възможност за теглене",
  安全中心: "Център за сигурност",
  收益划转: "Прехвърляне на доходност",
  通知中心: "Известия",
  "累计收益:": "Обща доходност:",
  注册用户: "Регистрирани потребители",
  奖励规则: "Правила за награди",
  帮助反馈: "Помощ и обратна връзка",
  邀请好友: "Поканване на приятели",
  恢复身份: "Възстановяване на самоличността",
  选择语言: "Избор на език",
  设置新的密码: "Задаване на нова парола",
  暂无活动: "Няма активни дейности",
  "月增长量(+)": "Месечен растеж (+)",
  可提取: "Възможност за изтегляне",
  反馈类型: "Тип обратна връзка",
  赠送: "Подарък",
  已经复制: "Копирано",
  保存成功: "Успешно запазване",
  划转成功: "Успешно прехвърляне",
  过期: "Изтекло",
  提交成功: "Успешно изпращане",
  "服务器繁忙，稍后在试": "Сървърът е зает, опитайте по-късно",
  全部: "Всички",
  一级: "Ниво 1",
  二级: "Ниво 2",
  三级: "Ниво 3",
  级: "Ниво",
  删除成功: "Успешно изтриване",
  选择地址: "Избор на адрес",
  不再提醒: "Да не се показва отново",
  "最小充值金额：": "Минимална сума за депозиране:",
  选择币种: "Избор на криптовалута",
  输入投资金额: "Въведете сума за инвестиране",
  输入账户密码: "Въведете парола за профила",
  投资: "Инвестиране",
  订单编号: "Номер на поръчка",
  投资周期: "Инвестиционен период",
  投资资金: "Инвестирана сума",
  投资时间: "Време на инвестиция",
  状态: "Състояние",
  投资中: "Активен",
  已到期: "Изтекъл",
  暂无数据: "Няма данни",
  转入: "Прехвърляне към",
  邮箱: "Имейл",
  请输入邮箱: "Въведете имейл",
  请输入格式正确的邮箱: "Въведете валиден имейл",
  请输入验证码: "Въведете код за потвърждение",
  获取验证码: "Получаване на код за потвърждение",
  请输入邀请码: "Въведете код за покана",
  今天: "Днес",
  昨天: "Вчера",
  最近七天: "Последните 7 дни",
  邀请: "Покана",
  购买数量: "Количество за закупуване",
  产品详情: "Детайли на продукта",
  币种: "Криптовалута",
  利息币种: "Валута на доходността",
  理财类型: "Тип финансов продукт",
  产品费率: "Такси за продукта",
  进行中: "Активен",
  每天: "Ежедневно",
  请输入搜索关键词: "Въведете ключова дума",
  通知: "Известия",
  查看更多: "Вижте повече",
  理财宝: "Финансови продукти",
  周期: "Продължителност",
  年利率: "Годишен лихвен процент (APY)",
  更多产品: "Още продукти",
  灵活存取: "Гъвкави спестявания",
  稳定收益: "Стабилна доходност",
  合约指南: "Ръководство за фючърси",
  资金划转出: "Изходящ превод",
  矿池收益: "Награда от копаене",
  提现手续费: "Такса за теглене",
  冻结资金: "Замразени средства",
  解冻资金: "Размразяване на замразени средства",
  闪兑支出: "Разход за бърза обмяна",
  闪兑收入: "Приход от бърза обмяна",
  闪兑手续费: "Такса за бърза обмяна",
  合约支出: "Разход за фючърси",
  合约收入: "Приход от фючърси",
  输入的金额不可大于可用金额: "Сумата не може да надвишава наличната сума",
  全部兑换成功: "Пълната обмяна е успешна",
  返回: "Назад",
  查看历史: "Преглед на история",
  闪兑历史: "История на бърза обмяна",
  支付: "Плащане",
  获取: "Получаване",
  时间: "Време",
  手续费: "Такса за транзакция",
  折扣: "Отстъпка",
  价格: "Цена",
  逐仓: "Изолиран маржин",
  全仓: "Кръстосан маржин",
  市价委托: "Пазарна поръчка",
  限价委托: "Лимитирана поръчка",
  请输入本金: "Въведете главница",
  请输入价格: "Въведете цена",
  "可做空/做多": "Възможност за шорт/лонг",
  设置止盈止损: "Задаване на тейк-профит/стоп-лос",
  止盈价: "Цена на тейк-профит",
  止损价: "Цена на стоп-лос",
  成本: "Себестойност",
  做多: "Лонг",
  做空: "Шорт",
  仓位信息: "Информация за позицията",
  一键平仓: "Затваряне на позиция (един клик)",
  永续: "Перпетуал",
  浮动盈亏: "Нереализирана печалба/загуба",
  平仓: "Затваряне на позиция",
  反向开仓: "Отваряне на обратна позиция",
  一键撤销: "Отмяна на всички (един клик)",
  倍杠杆: "кратен ливъридж",
  执行价格: "Цена на изпълнение",
  委托数量: "Количество на поръчката",
  保证金: "Маржин",
  成交价: "Цена на изпълнение",
  创建时间: "Време на създаване",
  撤销: "Отмяна",
  合约市场: "Пазар на фючърси",
  交易方向: "Посока на търговия",
  委托价格: "Цена на поръчката",
  委托金额: "Сума на поръчката",
  资金费率: "Лихвен процент на финансиране",
  "多方和空方交易者支付的定期费用，每8小时结算一次。":
    "Периодична такса, плащана от дълги и къси позиции, уреждана на всеки 8 часа.",
  "资金费率为正，多方向空方支付资金费用。":
    "При положителен лихвен процент на финансиране, дългите позиции плащат на късите позиции.",
  "资金费率为负，空方向多方支付资金费用。":
    "При отрицателен лихвен процент на финансиране, късите позиции плащат на дългите позиции.",
  "确定反向开仓吗？反向开仓将以当期相反 的仓位进行买入":
    "Сигурни ли сте, че искате да отворите обратна позиция? Това ще закупи противоположната посока на текущата ви позиция.",
  "仓位止盈/止损": "Тейк-профит/Стоп-лос за позиция",
  合约名称: "Фючърсен договор",
  开仓价格: "Цена на отваряне",
  指数价格: "Индексна цена",
  止盈设置: "Настройки на тейк-профит",
  请输入止盈价: "Въведете цена на тейк-профит",
  "当指数价格触达*时，将会触发委托平仓":
    "Когато индексната цена достигне *, ще бъде активирана поръчка за затваряне.",
  预计盈亏: "Очаквана печалба/загуба",
  当前仓位: "Текуща позиция",
  平仓金额: "Сума за затваряне",
  仓位模式: "Режим на позиция",
  全仓模式: "Режим на кръстосан маржин",
  "合约账户中的所有可用资金视作为可用保证金， 当仓位亏损超过了账户余额才会爆仓强平，并将损失所有 保证金和仓位，请注意":
    "В режим на кръстосан маржин, всички налични средства във вашата сметка за фючърси се използват като маржин. Ликвидация настъпва, когато загубата надвиши общия ви баланс, което води до загуба на целия ви маржин и позиция.",
  逐仓模式: "Режим на изолиран маржин",
  "会使合约账户中的一定数量保证金被分配到仓位上。如果保证金亏损低于维持保证金的水平，仓位被强平。在逐仓模式下，您可以为这个仓位增加和减少保证金。":
    "Определена сума маржин се разпределя към позиция. Ако загубата на маржин падне под нивото на поддържащия маржин, позицията се ликвидира. В режим на изолиран маржин можете да увеличавате или намалявате маржина за тази позиция.",
  "是否撤销？": "Отмяна на поръчката?",
  "是否一键撤销？": "Отмяна на всички поръчки?",
  "是否一键平仓？": "Затваряне на всички позиции?",
  持仓保证金: "Маржин на текущата позиция",
  风险率: "Коефициент на риск",
  未实现盈亏: "Нереализирана печалба/загуба",
  可用保证金: "Наличен маржин",
  净值: "Нетна стойност",
  账户余额: "Баланс на профила",
  合约计算器: "Калкулатор за фючърси",
  交易记录: "История на транзакциите",
  "*倍杠杆": "*кратен ливъридж",
  "平仓盈亏：": "Реализирана печалба/загуба:",
  时间筛选: "Филтър за време",
  仓位类型: "Тип позиция",
  订单状态: "Състояние на поръчката",
  订单类型: "Тип поръчка",
  平仓价格: "Цена на затваряне",
  持仓数量: "Количество на позицията",
  "手续费(%)": "Такса за транзакция (%)",
  平仓时间: "Време на затваряне",
  平仓类型: "Тип на затваряне",
  手动平仓: "Ръчно затваряне",
  强制平仓: "Принудителна ликвидация",
  近1天: "Последният ден",
  近7天: "Последните 7 дни",
  近30天: "Последните 30 дни",
  近180天: "Последните 180 дни",
  持仓: "Отворена позиция",
  已取消: "Отменено",
  分时: "В рамките на деня",
  "24H额(USDT)": "Обем 24ч (USDT)",
  "24H低": "24ч минимум",
  "24H量(BTC)": "Обем 24ч (BTC)",
  "24H高": "24ч максимум",
  "10秒": "10 секунди",
  "30秒": "30 секунди",
  "1分": "1 минута",
  "3分": "3 минути",
  "5分": "5 минути",
  "30分": "30 минути",
  "1小时": "1 час",
  "4小时": "4 часа",
  "8小时": "8 часа",
  "1天": "1 ден",
  "1周": "1 седмица",
  "1月": "1 месец",
  单向持仓: "Еднопосочна позиция",
  杠杆: "Ливъридж",
  仓位: "Позиция",
  计算结果: "Резултат",
  盈亏: "Печалба/Загуба",
  收益率: "Доходност",
  计算结果仅供参考: "Резултатът е ориентировъчен",
  成交后仓位大小: "Размер на позицията след изпълнение",
  "计算结果仅供参考,实际结果可能因费率差异":
    "Резултатът е ориентировъчен, действителните резултати могат да варират поради такси.",
  目标价格: "Целева цена",
  开始计算: "Изчисляване",
  强平价格: "Цена на ликвидация",
  "充值前，请认真核对充值的链名称，充值错误无法找回资产*最小充值金额为*；少于此金额平台将无法确认到账，请不要向此地址充值*之外的资产，否则将无法找回资产，请不要直接提现众筹或者ICO地址，平台不会代理币的发放。":
    "Проверете внимателно името на веригата преди депозиране. Грешните депозити не могат да бъдат отменени. Минималната сума за депозиране е *. Депозити под тази сума няма да бъдат обработени. Не изпращайте други активи на този адрес. Не използвайте ICO или адреси за групово финансиране за теглене.",
  "最小输入*": "Минимум {0}",
  "最小提币数量为*，提币手续费将从你的提款金额中扣除。提币前请确认核对收款地址，不要将*提现至*以外的地址，否则无法找回资产。请不要直接提现众筹或者ICO地址，平台不会处理代币的发放。":
    "Минималното количество за теглене е *. Таксите за теглене ще бъдат удържани от сумата за теглене. Проверете внимателно адреса на получателя. Не изпращайте * на адреси извън *. Не използвайте ICO или адреси за групово финансиране.",
  退出登录: "Изход",
  加仓: "Увеличаване на позицията",
  新增仓位: "Нова позиция",
  输入加仓金额: "Въведете сума за увеличаване на позицията",
  "当前可用:": "Текущо налично:",
  资产账单: "Фактура за активи",
  保存二维码: "Запазване на QR код",
  温馨提示: "Забележка",
  "请注意：您当前使用的网络": "Забележка: Понастоящем използвате мрежата",
  输入提现地址: "Въведете адрес за теглене",
  "可用金额：": "Налична сума:",
  输入资产密码: "Въведете парола за активите",
  可用手续费: "Налична такса",
  "折扣%": "Отстъпка %",
  实扣手续费: "Реално начислена такса",
  实际到账: "Реално получена сума",
  未设置资产密码: "Не е зададена парола за активите",
  "为了您的资产安全，请设置资产密码后再来提现。":
    "За ваша сигурност, задайте парола за активите, преди да направите теглене.",
  热榜: "Популярни",
  涨幅榜: "Най-големи увеличения",
  跌幅榜: "Най-големи спадове",
  成交额榜: "Класация по обем",
  关于我们: "За нас",
  登录密码: "Парола за вход",
  设置: "Настройки",
  资产密码: "Парола за активите",
  修改登录密码: "Промяна на паролата за вход",
  原密码: "Стара парола",
  请输入新密码: "Въведете нова парола",
  请输入原密码: "Въведете стара парола",
  确认密码: "Потвърждаване на паролата",
  确定修改: "Потвърждаване на промяната",
  修改资产密码: "Промяна на паролата за активите",
  验证码: "Код за потвърждение",
  资产密码使用提示: "Съвети за парола за активите",
  "资产密码用于转移、提取资产和交易。":
    "Паролата за активите се използва за прехвърляне, теглене и търговия с активи.",
  "创建与登录密码不同的资产密码。":
    "Създайте парола за активите, различна от паролата за вход.",
  "定期更改您的资产密码。": "Променяйте редовно паролата си за активите.",
  提币历史: "История на тегленията",
  "金额/余额": "Сума/Баланс",
  "手续费/折扣": "Такса/Отстъпка",
  自选: "Любими",
  现货: "Спот",
  市价: "Пазарна цена",
  止损设置: "Настройки на стоп-лос",
  合约K线图: "Графика на фючърси",
  "24H量": "Обем 24ч",
  "24H额": "Обем 24ч (USDT)",
  合作指南: "Ръководство за партньори",
  盈亏计算: "Изчисляване на печалба/загуба",
  当前可用: "Текущо налично",
  请输入加仓金额: "Въведете сума за увеличаване на позицията",
  请重新输入加仓金额: "Въведете отново сумата за увеличаване на позицията",
  平仓数量: "Количество за затваряне",
  欢迎登录: "Добре дошли отново",
  "忘记密码?": "Забравена парола?",
  "还没有账号？": "Все още нямате профил?",
  立即注册: "Регистрирайте се сега",
  繁體中文: "Традиционен китайски",
  找回密码: "Възстановяване на парола",
  下一步: "Напред",
  注册账户: "Регистриране на профил",
  "请输入邀请码(选填)": "Въведете код за покана (по избор)",
  谢邀豪礼: "Бонус за покана",
  "24小时邀请好友排名": "24-часова класация за покани",
  "*人": "* души",
  "差*人": "Не достигат * души",
  "已超过10万人，每月轻松赚钱":
    "Над 100 000 потребители, печелете лесно всеки месец",
  最高: "Максимум",
  邀请链接: "Линк за покана",
  "平台和您共享好友在平台（现货、合约、杠杆、闪兑）所产生的手续费":
    "Споделете таксите за транзакции, генерирани от вашите приятели (спот, фючърси, ливъридж, бърза обмяна).",
  平台和您一起分享手续费: "Споделете таксите за транзакции с платформата",
  "*级": "* ниво",
  规则: "Правила",
  我的好友: "Моите приятели",
  好友详情: "Детайли за приятел",
  获得好友佣金方案: "План за комисионна от приятели",
  我的等级: "Моето ниво",
  我的邀请数据: "Моите данни за покани",
  当前等级: "Текущо ниво",
  平台奖励您: "Награда от платформата за вас",
  最高可获取平台奖励: "Максимална награда от платформата",
  邀请规则: "Правила за поканване",
  "邀请*级有效好友": "Поканете активни приятели от ниво *",
  好友等级: "Ниво на приятел",
  人: "души",
  奖金派送: "Изплащане на бонус",
  平台奖励: "Награда от платформата",
  "最终解释权归平台所有，若发现异常获取平台奖励，将会扣除所有的奖励，并且冻结账户，资产的损失将无法找回。":
    "Платформата си запазва правото на окончателно тълкуване. При измамни дейности наградите ще бъдат отнети и профилът ви ще бъде замразен. Изгубените активи не могат да бъдат възстановени.",
  "您的账户必须是有效账户，平台判定有效账户条件为（账户充值任何币种）最小* USDT的价值。":
    "Вашият профил трябва да бъде активен, определен като депозит на стойност най-малко * USDT във всяка криптовалута.",
  "您邀请的好友，必须是有效下级，平台判定有效下级为（账户充值任何币种）最小* USDT的价值。":
    "Поканеният от вас приятел трябва да бъде активен долен ред, определен като депозит на стойност най-малко * USDT.",
  "邀请人和被邀请者的账号不能同属于一个IP。":
    "Канящият и поканеният не могат да споделят един и същ IP адрес.",
  "VIP等级由您邀请的*级好友的人数作为考核。":
    "VIP нивото се определя от броя на поканените приятели от ниво *.",
  佣金成分: "Компоненти на комисионната",
  收益统计: "Статистика на доходността",
  昨日收益: "Вчерашна доходност",
  月收益: "Месечна доходност",
  获取收益: "Получаване на доходност",
  "总收益：": "Обща доходност:",
  "*级好友": "Приятели от ниво *",
  理财购买: "Закупуване на финансов продукт",
  期限: "Продължителност",
  可用金额: "Налична сума",
  预估收益: "Очаквана доходност",
  申购上限: "Максимално закупуване",
  项目剩余: "Оставащ проект",
  "买入后预计*(SGT)开始计算收益。":
    "Доходността се очаква да започне да се начислява около *(SGT) след покупката.",
  计息日: "Начало на олихвяване",
  申购日: "Дата на закупуване",
  到账日: "Дата на кредитиране",
  到期自动续投: "Автоматично реинвестиране при изтичане",
  申购: "Закупуване",
  搜索理财项目: "Търсене на финансов продукт",
  超高年化随心选: "Изберете от продукти с висока доходност",
  "自由选择理财币种，稳定超额收益":
    "Свободно изберете своята криптовалута за стабилна, над средната доходност",
  理财总资产: "Общо инвестирани активи",
  申购数量: "Количество за закупуване",
  立即购买: "Купуване веднага",
  年化收益率: "Годишен процент на доходност (APY)",
  理财订单: "Поръчки за финансови продукти",
  持有: "В притежание",
  申购份额: "Закупен дял",
  到账日期: "Дата на кредитиране",
  申购成功: "Успешно закупуване",
  到期: "Изтекъл",
  是否选择做多: "Отваряне на лонг позиция?",
  "可用余额为0 不能操作": "Балансът е 0, действието не е възможно",
  福利中心: "Център за бонуси",
  奖励记录: "История на наградите",
  我获取到的奖励: "Моите получени награди",
  总价值: "Обща стойност",
  新手任务: "Задачи за нови потребители",
  身份认证: "Потвърждаване на самоличност (KYC)",
  身份验证: "Потвърждаване на самоличност",
  去验证: "Потвърдете сега",
  审核中: "В изчакване",
  已验证: "Потвърден",
  认证失败: "Потвърждението не бе успешно",
  基础认证: "Основно потвърждение",
  "请注意认证信息一经验证不能修改，务必填写准确信息":
    "Забележка: Потвърдената информация не може да бъде променяна. Въведете точни данни.",
  "国家/地区": "Държава/Регион",
  请选择: "Изберете",
  证件类型: "Тип документ",
  证件编码: "Номер на документа",
  身份证: "Лична карта",
  护照: "Паспорт",
  驾驶证: "Шофьорска книжка",
  请输入编码: "Въведете номер",
  名字: "Име",
  请输入: "Въведете",
  中间名: "Презиме",
  选填: "По избор",
  姓氏: "Фамилия",
  中国: "Китай",
  身份上传: "Качване на документ за самоличност",
  上传身份证: "Качване на лична карта",
  "以上材料需要用JPG/JPEG/PNG格式上传，并且保证照片的清晰边角完整，亮度均匀。且大小不超过*M。":
    "Качете в JPG/JPEG/PNG формат. Уверете се, че изображенията са ясни, пълни и равномерно осветени. Максимум *MB.",
  确定提交: "Изпращане",
  去认证: "Потвърждаване",
  挑战任务: "Предизвикателства",
  注册认证任务: "Задача за регистрация и потвърждение",
  完成注册认证即可领取:
    "Завършете регистрацията и потвърждението, за да получите",
  领取奖励: "Получаване на награда",
  新人豪礼: "Добре дошли бонус",
  "参与人数：": "Брой участници:",
  条件: "Условие",
  入金量: "Сума на депозита",
  完成: "Завършено",
  任务奖励: "Награда за задача",
  距任务更新: "До актуализиране на задачата",
  "条件：": "Условие:",
  活动规则: "Правила на дейността",
  奖励明细: "Детайли на наградата",
  已获得: "Получено",
  交易奖励: "Награда за търговия",
  Win奖励: "WIN награда",
  已领取: "Получено",
  亏损金额超过: "Сумата на загубата надвишава",
  单笔开仓金额超过: "Сумата на единична поръчка надвишава",
  交易量: "Обем на търговия",
  待完成: "В очакване",
  入金: "Депозит",
  盈利金额超过: "Сумата на печалбата надвишава",
  开仓金额: "Сума на поръчката",
  开仓金: "Сума на поръчката",
  盈利: "Печалба",
  亏损: "Загуба",
  领取: "Получаване",
  未领取: "Не е получено",
  待领取: "За получаване",
  再交易: "Търгувайте допълнително",
  即可获得: "за да получите",
  领取成功: "Успешно получаване",
  "1、所有的活动都会按照活动最后的时间进行统计收益过期后将无效。":
    "1. Всички дейности ще бъдат уредени на крайната дата. Наградите изтичат след това.",
  "2、获得的收益会发放到您的赏金账户中，你可以随时根据您的需要进行兑换和提现。":
    "2. Получената доходност ще бъде кредитирана в бонус профила ви, който можете да обменяте или теглите по всяко време.",
  "3、获取的到的奖励币种类型根据任务按类型发放。":
    "3. Криптовалутата на наградата зависи от задачата.",
  "4、最终解释权归平台所有，若发现存在异常手段套利平台的任务奖金，平台有权冻结并且清除您获取的收益。":
    "4. Платформата си запазва правото на окончателно тълкуване. При измама със задачите, наградите ще бъдат задържани и профилът ви може да бъде замразен.",
  成长学院: "Академия",
  "区块链 & 加密货币": "Блокчейн и криптовалута",
  "您的加密货币一站式指南，我们带您开启加密货币之路。":
    "Вашето пълно ръководство за криптовалута. Ние ви съпътстваме в крипто пътуването ви.",
  "全仓合约定单的全部保证金。": "Общ маржин за поръчки с кръстосан маржин.",
  "(账户余额+(浮动盈亏-手续费-过夜费)=净值/已用保证金*100":
    "(Баланс + (нереализирана печалба/загуба - такси - лихви за финансиране) = Нетна стойност / Използван маржин * 100",
  "浮动盈亏会直接影响”可用保证金“，当未实现盈亏增加，可用保证金将会增加，未实现盈亏减少，可用保证金同样也会减少。":
    "Нереализираната печалба/загуба пряко влияе на 'наличен маржин'. Ако нереализираната печалба/загуба се увеличи, наличният маржин се увеличава и обратно.",
  "账户余额-(已用保证金)+(浮动盈亏-手续费-过夜费)":
    "Баланс - (Използван маржин) + (нереализирана печалба/загуба - такси - лихви за финансиране)",
  "注:可继续用于开仓的保证金。":
    "Забележка: Маржин, който е наличен за отваряне на нови позиции.",
  "账户余额+(浮动盈亏-手续费-过夜费)":
    "Баланс + (нереализирана печалба/загуба - такси - лихви за финансиране)",
  "注:当前的资金结余。": "Забележка: Текущ баланс.",
  "指的是合约账户的全部余额，包含不可用余额。":
    "Отнася се за общия баланс на сметката за фючърси, включително замразените суми.",
  "注:风险率越高，风险越低，风险率越低，风险越高。":
    "Забележка: Колкото по-висок е коефициентът на риск, толкова по-нисък е рискът и обратно.",
  该功能尚未开发: "Тази функция все още е в процес на разработка",
  重置密码: "Нулиране на парола",
  "请输入为8-20位，必须包含字母、数字和特殊字符":
    "Въведете 8-20 знака, включително букви, цифри и специални знаци",
  修改成功: "Успешна промяна",
  输入验证码: "Въведете код за потвърждение",
  输入密码: "Въведете парола",
  详情说明: "Подробности",
  已售罄: "Изчерпан",
  剩余期限: "Оставащ срок",
  限期: "Срок",
  闪兑货币选择: "Избор на валута за бърза обмяна",
  地区选择: "Избор на регион",
  "搜索国家/地区": "Търсене на държава/регион",
  "身份信息已提交，将在*小时内审核完成":
    "Данните за самоличност са изпратени. Обработката ще отнеме до * часа.",
  "选择国家/地区": "Изберете държава/регион",
  "止盈价格需高于*": "Цената на тейк-профит трябва да бъде по-висока от *",
  "止损价格需低于*": "Цената на стоп-лос трябва да бъде по-ниска от *",
  "止盈价格需低于*": "Цената на тейк-профит трябва да бъде по-ниска от *",
  "止损价格需高于*": "Цената на стоп-лос трябва да бъде по-висока от *",
  教程详情: "Подробности на урока",
  请输入止损价: "Въведете цена на стоп-лос",
  活期: "Гъвкав",
  赎回后立即到账: "Незабавно кредитиране след обратно изкупуване",
  赎回: "Обратно изкупуване",
  赎回理财: "Обратно изкупуване на финансов продукт",
  是否赎回当前的理财订单:
    "Обратно изкупуване на текущата поръчка за финансов продукт?",
  维护: "Поддръжка",
  "系统正在维护中……": "Системата е в поддръжка...",
  合约: "Фючърси",
  闪电兑换: "Бърза обмяна",
  流水挖矿: "Копаене на обем",
  邀请豪礼: "Бонус за покана",
  计算器: "Калкулатор",
  最新价: "Последна цена",
  涨跌幅: "Промяна (24ч)",
  关注币种添加自选: "Добавяне на криптовалута към любими",
  一键添加自选: "Добавяне към любими (един клик)",
  全标已读: "Отбелязване на всички като прочетени",
  无消息: "Няма съобщения",
  "暂时还没有收到任何消息通知哦!": "Все още не сте получили никакви известия!",
  没有更多数据: "Няма повече данни",
  闪兑: "Бърза обмяна",
  从: "От",
  "可用余额：": "Наличен баланс:",
  至: "До",
  预览兑换结果: "Преглед на резултата от обмяната",
  闪兑规则: "Правила за бърза обмяна",
  "市场闪兑可能变动，请以实际到账的金额数量为准。":
    "Бързата обмяна подлежи на пазарни колебания. Реално получената сума е обвързваща.",
  "对汇兑率由第三方制定，由于兑换成本以及市场波动，您兑换的汇率可能会高于市场的汇率，请仔细确认后进行操作。":
    "Обменните курсове се определят от трети страни. Поради разходи и колебания, курсът може да се различава от пазарния курс. Проверете внимателно.",
  "平台对每笔汇兑收取大约*%的手续费，用于支付在交易所兑换成本。":
    "Платформата начислява приблизително *% такса за обмяна, за да покрие разходите на борсите.",
  确认汇兑: "Потвърждаване на обмяната",
  您预估得到: "Очаквано получаване",
  汇兑: "Обмяна",
  汇兑比例: "Обменен курс",
  刷新: "Опресняване",
  兑换: "Обмяна",
  没有更多了: "Няма повече данни",
  搜索币种: "Търсене на криптовалута",
  可用: "Наличен",
  我知道了: "Разбрах",
  最新价格: "Последна цена",
  确认: "Потвърди",
  最大: "Максимум",
  "风险率(%)": "Коефициент на риск (%)",
  当前委托: "Текущи поръчки",
  合作交易历史记录: "История на транзакциите на партньора",
  重置: "Нулиране",
  余额: "Баланс",
  现货账户: "Спот сметка",
  合约账户: "Сметка за фючърси",
  WIN账户: "WIN сметка",
  赏金账户: "Бонус сметка",
  总资产折合: "Общо активи (в USDT)",
  今日收益: "Днешна доходност",
  充币: "Депозиране",
  提币: "Теглене",
  账户权益: "Стойност на профила",
  "数量/类别": "Количество/Категория",
  全部币种: "Всички криптовалути",
  全部类型: "Всички типове",
  账单信息: "Информация за фактура",
  理财赎回: "Обратно изкупуване на финансов продукт",
  购买理财: "Закупуване на финансов продукт",
  收入: "Приходи",
  支出: "Разходи",
  到: "към",
  资产划转: "Прехвърляне на активи",
  "最少*": "Минимум *",
  "可用资产：": "Налични активи:",
  确认划转: "Потвърждаване на прехвърлянето",
  "只有将资产划转至对于的账户才可以进行交易，账户间的划转不收取手续费。":
    "Трябва да прехвърлите активи към правилния профил, за да можете да търгувате. Прехвърлянията между профили са безплатни.",
  币种账户选择: "Избор на сметка за криптовалута",
  选择账户: "Избор на профил",
  划转详情: "Детайли на прехвърлянето",
  划转明细: "Спецификация на прехвърлянето",
  收入账单: "Фактура за приходи",
  支出账单: "Фактура за разходи",
  金额: "Сума",
  总收益: "Обща доходност",
  佣金: "Комисионна",
  用户名: "Потребителско име",
  "已领取：": "Получено:",
  "未领取：": "Не е получено:",
  "请选择国家/地区": "Изберете държава/регион",
  请上传身份信息: "Качете данни за самоличност",
  请选择证件类型: "Изберете тип документ",
  请填写证件编码: "Въведете номер на документа",
  请填写名字: "Въведете име",
  请填写姓氏: "Въведете фамилия",
  投资金额: "Сума на инвестицията",
  天: "дни",
  请输入手机号: "Въведете телефонен номер",
  搜索: "Търсене",
  搜索历史: "История на търсенията",
  热门推荐: "Популярни препоръки",
  "《Xspace Earn协议》": "Протокол Xspace Earn",
  我已了解并同意: "Разбирам и съм съгласен",
  协议: "Протокол",
  Xspace官方中文交流群: "Официална китайска общност Xspace",
  Xspace官方英文交流群: "Официална английска общност Xspace",
  预计维护至: "Очаквана поддръжка до",
  更多功能: "Повече функции",
  下载APP: "Изтегляне на приложение",
  理财: "Финансов продукт",
  推荐: "Препоръчано",
  Telegram官方中文频道: "Официален Telegram канал (китайски)",
  Telegram官方英文频道: "Официален Telegram канал (английски)",
  官方邮箱: "Официален имейл",
  客服邮箱: "Имейл на обслужване на клиенти",
  上述信息最终解释权归官方所有:
    "Горната информация подлежи на официално тълкуване на платформата.",
  IOS版下载: "Изтегляне за iOS",
  Android版下载: "Изтегляне за Android",
  "手续费=买入手续费+资金费率+卖出手续费":
    "Такса за транзакция = Такса за покупка + Лихвен процент на финансиране + Такса за продажба",
  资金划转: "Прехвърляне на средства",
  止盈: "Тейк-профит",
  止损: "Стоп-лос",
  自动平仓: "Автоматично затваряне",
  委托挂单: "Отворена поръчка",
  买: "Купуване",
  卖: "Продаване",
  "买入/做多": "Купуване/Лонг",
  "卖出/做空": "Продаване/Шорт",
  详情: "Подробности",
  浮动涨跌: "Нереализирана печалба/загуба",
  最小: "Минимум",
  充币数量: "Количество за депозиране",
  请输入充币数量: "Въведете количество за депозиране",
  支付截图: "Доказателство за плащане",
  提交: "Изпращане",
  上传驾驶证: "Качване на шофьорска книжка",
  上传护照: "Качване на паспорт",
  加载中: "Зареждане...",
  上传成功: "Успешно качване",
  充值历史: "История на депозитите",
  合约卖出手续费: "Такса за продажба на фючърси",
  合约买入手续费: "Такса за покупка на фючърси",
  系统加款: "Системно кредитиране",
  系统减款: "Системно дебитиране",
  合约资金费率: "Лихвен процент на финансиране на фючърси",
  佣金分成: "Разпределение на комисионната",
  U本位合约: "Фючърси с маржин в USDT",
  资产管理: "Управление на активи",
  APP下载: "Изтегляне на приложение",
  全球领先的数字理财平台:
    "Световно водеща платформа за дигитално управление на богатството",
  "即刻交易比特币、以太坊等上百种数字资产":
    "Търгувайте незабавно с Bitcoin, Ethereum и стотици други дигитални активи",
  "24H涨跌幅": "24ч промяна",
  查看更多行情: "Вижте повече пазари",
  近24小时成交量: "Обем 24ч",
  "提供数百种币币和合约交易对，以满足多样化的交易需求。 平台在200个国家和地区中有超过2千万用户，是全球领先的数字资产服务平台。":
    "Предлага стотици спот и фючърс двойки. Над 20 милиона потребители в над 200 държави. Световно водеща платформа за услуги с дигитални активи.",
  用户国家分布: "Потребители по държави",
  用户数: "Брой потребители",
  交易对: "Търговски двойки",
  服务支持: "Поддръжка",
  "随时随地，多平台终端交易":
    "Търгувайте навсякъде с поддръжка на множество платформи",
  "多终端完美兼容，随时满足各种场景的交易需求。":
    "Съвместим с множество устройства за всички търговски нужди.",
  随时查看实时行情: "Виждайте цените в реално време навсякъде",
  "轻松买卖BTC，ETH，DOGE和其他数字资产":
    "Лесно купувайте и продавайте BTC, ETH, DOGE и други дигитални активи",
  获取您关注的加密货币价格变化预警:
    "Получавайте ценови предупреждения за криптовалути, които следвате",
  "查看比特币现货、期货、期权价格":
    "Вижте цените на спот, фючърси и опции за Bitcoin",
  比较各交易所加密货币价格:
    "Сравнете цените на криптовалутите в различните борси",
  开启您的数字货币之旅: "Започнете своето пътешествие с дигитални активи",
  快捷购买数字货币: "Бързо купуване на криптовалути",
  "使用多种支付方式交易数字货币，安全快捷":
    "Търгувайте безопасно и бързо с множество начини на плащане",
  最优的交易费率: "Най-добрите такси за транзакции",
  "优惠的交易费率，富有竞争力的VIP权益，享受最优品质的服务":
    "Изгодни цени, конкурентни VIP предимства и услуги от най-високо качество.",
  可信赖的安全保障: "Надеждна сигурност",
  "我们复杂的安全措施和SAFU基金保护您的数字资产免受所有风险。":
    "Разширените мерки за сигурност и фондът SAFU защитават вашите активи от рискове.",
  交易: "Търговия",
  币币市场: "Спот пазар",
  "24H成交量": "Обем 24ч",
  交易所: "Борса",
  "24H最高": "24ч максимум",
  "24H最低": "24ч минимум",
  永续合约: "Перпетуални фючърси",
  日涨跌: "Дневна промяна",
  交易深度: "Дълбочина на книгата с поръчки",
  "资产(合约)": "Активи (Фючърси)",
  历史仓位: "История на позициите",
  兑换记录: "История на обмените",
  类型: "Тип",
  充值记录: "История на депозитите",
  划转记录: "История на прехвърлянията",
  类别: "Категория",
  历史账单: "История на фактурите",
  在线充值: "Онлайн депозиране",
  安全设置: "Настройки за сигурност",
  用于账户登录使用: "Използва се за влизане в профила",
  用户提现时安全验证使用: "Използва се за проверка на сигурността при теглене",
  验证: "Потвърждаване",
  万: "милион",
  随时随地开启交易: "Започнете търговия навсякъде",
  "*货币交易所的所有功能尽在你的手中。":
    "Всички функции на * борсата за криптовалути в ръцете ви.",
  "下载*货币交易所APP。":
    "Изтеглете приложението на * борсата за криптовалути.",
  下载自: "Изтегляне от",
  内测版: "Бета версия",
  下载: "Изтегляне",
  扫码下载: "Сканирайте за изтегляне",
  设置您的资产密码: "Задайте своята парола за активите",
  法币: "Фиат",
  我要买: "Искам да купя",
  我要卖: "Искам да продам",
  请输入金额: "Въведете сума",
  汇率: "Обменен курс",
  获得: "Получаване",
  支付通道: "Канал за плащане",
  收款通道: "Канал за получаване",
  "出售过程需要务必确认好您的收款方式为本人。":
    "Уверете се, че каналът за получаване е на ваше име, когато продавате.",
  当前法币暂不支持交易对可尝试前往提现:
    "Тази фиат двойка в момента не се поддържа. Опитайте теглене.",
  前往提现: "Отидете на теглене",
  该法币暂无通道: "Няма наличен канал за тази фиат валута",
  "正在出售中，请耐心等待": "Продажбата е в ход, моля изчакайте",
  请选择支付通道: "Изберете канал за плащане",
  请选择方式: "Изберете метод",
  法币历史: "Фиат история",
  买币: "Купуване на криптовалута",
  卖币: "Продаване на криптовалута",
  失败: "Неуспешно",
  已完成: "Завършено",
  未付款: "Неплатено",
  待审核: "В изчакване",
  打款中: "Плащането е в ход",
  订单详情: "Детайли на поръчката",
  联系客服: "Свържете се с поддръжката",
  到账金额: "Получена сума",
  通道: "Канал",
  收款人: "Получател",
  收款账户: "Сметка на получателя",
  "订单出售失败，请查下方失败原因":
    "Продажбата на поръчката бе неуспешна. Вижте причината по-долу.",
  失败原因: "Причина за неуспеха",
  您还未进行付款: "Все още не сте платили",
  您已成功购买: "Покупката бе успешна",
  已取消订单: "Поръчката е отменена",
  "订单正在审核中，请耐心等待": "Поръчката се обработва. Моля изчакайте.",
  您已成功出售: "Продажбата бе успешна",
  "订单正在打款中，请耐心等待": "Плащането е в ход. Моля изчакайте.",
  "支付过程需要您前往其他的平台进行支付订单，请注意信息安全。":
    "За плащане трябва да посетите друга платформа. Обърнете внимание на сигурността на информацията си.",
  当前法币暂不支持交易对可尝试前往充值:
    "Тази фиат двойка в момента не се поддържа. Опитайте депозит.",
  前往充值: "Отидете на депозит",
  购买: "Купуване",
  订单号: "Номер на поръчка",
  单价: "Единична цена",
  到账数量: "Получено количество",
  "当前存在未付的订单，是否继续发起新的支付订单？":
    "Има неплатена поръчка. Искате ли да започнете нова поръчка за плащане?",
  继续支付: "Продължаване на плащането",
  重新下单: "Нова поръчка",
  是否确定出售: "Сигурни ли сте, че искате да продадете?",
  "确定出售后，平台将分配给买家，请耐心等待平台的撮合。":
    "След потвърждение, платформата ще назначи купувач. Изчакайте съвпадението.",
  出售: "Продаване",
  收款方式: "Метод на получаване",
  订单已生成: "Поръчката е генерирана",
  取消订单: "Отмяна на поръчката",
  请在: "Моля, в рамките на",
  内完成付款: "завършете плащането",
  "离开平台，登录您指定的支付，转账到卖家的以下账户，并务必在付款中备注：":
    "Напуснете платформата, влезте в избрания от вас метод на плащане и преведете сумата на следната сметка на продавача. Винаги посочвайте референцията:",
  "若付款时未进行备注，卖家将无法确认收款，造成资产损失无法找回。":
    "Без референция продавачът няма да може да потвърди плащането, което може да доведе до загуба на активи.",
  "未在规定的时间内付款，订单都将被取消。":
    "Ако не платите в определеното време, поръчката ще бъде отменена.",
  姓名: "Име",
  收款姓名: "Име на получателя",
  开户支行: "Клон на банката",
  银行卡号: "Номер на банкова карта",
  "付款后，返回本平台": "След плащане, върнете се на тази платформа",
  "请务必点击下方“我已完成付款，通知卖家”按钮":
    "Натиснете бутона 'Завърших плащането, уведомете продавача'",
  未点击卖家不会放款:
    "Продавачът ще освободи криптовалутата само след като натиснете бутона",
  交易条款: "Условия на транзакцията",
  "购买资金来源，必须合法安全的资金，方可交易":
    "Средствата за покупка трябва да бъдат законни и безопасни",
  "不允许诈骗、传销、赌博或者其他非法资金交易":
    "Измами, пирамидални схеми, хазарт или други незаконни средства не са разрешени",
  "交易完成后，出现资金风险，被冻结或者涉嫌欺诈、传销、赌博的资金，我方将不在向买方放U，并给予退款":
    "Ако след транзакцията средствата бъдат замразени или са подозрителни, няма да освободим USDT и ще направим възстановяване",
  "已付款，通知卖家": "Платено, уведомете продавача",
  "买方当日累计取消*笔订单，将会取消当日购买功能。确定取消该订单吗？":
    "Ако днес отмените общо * поръчки, правото ви за покупка за деня ще бъде отменено. Да отмените тази поръчка?",
  添加收款方式: "Добавяне на метод за получаване",
  是否删除此收款方式: "Изтриване на този метод за получаване?",
  删除: "Изтриване",
  请选择法币: "Изберете фиат валута",
  机构名称: "Име на институцията",
  请选择机构: "Изберете институция",
  "当您出售数字货币时，您选择的收款方式将向买方展示，请确认填写无误。":
    "Избраният от вас метод за получаване ще бъде показан на купувачите, когато продавате криптовалута. Уверете се, че данните са правилни.",
  请选择银行: "Изберете банка",
  请输入姓名: "Въведете име",
  账号: "Номер на сметка",
  请输入账号: "Въведете номер на сметка",
  收款码: "Код за получаване",
  "银行账号/卡号": "Банкова сметка/Номер на карта",
  "请输入银行账号/卡号": "Въведете банкова сметка/номер на карта",
  "开户支行（选填）": "Клон на банката (по избор)",
  请输入开户支行: "Въведете клон на банката",
  "加入*官方频道": "Присъединете се към официалния * канал",
  关于: "За нас",
  条款: "Условия",
  成功: "Успех",
  等待: "Изчакване",
  作废: "Невалиден",
  确认付款: "Потвърждаване на плащането",
  "是否已完成付款？若确认付款后，商家将会在*分内进行确认是否收到付款。":
    "Плащането завършено? След потвърждение, продавачът ще потвърди получаването в рамките на * минути.",
  最大金额: "Максимална сума",
  最小金额: "Минимална сума",
  付款: "Плащане",
  法币充值: "Фиат депозит",
  法币提现: "Фиат теглене",
  待支付: "За плащане",
  已支付: "Платено",
  商户名: "Име на продавача",
  当前没有添加支付方式: "Няма добавен метод на плащане",
  添加后再出售: "Добавете един, преди да продадете",
  新人大礼包: "Пакет за добре дошли",
  注册即可领取: "Получете след регистрация",
  立即领取: "Получете сега",
  不再提示: "Да не се показва отново",
  "该奖励需在APP中领取，请下载APP":
    "Тази награда може да бъде получена само в приложението. Изтеглете приложението.",
  去交易: "Отидете на търговия",
  期权交易: "Търговия с опции",
  交易额: "Сума на търговия",
  可用额度: "Наличен лимит",
  交易周期: "Период на търговия",
  看涨: "Бичи (Call)",
  看跌: "Мечи (Put)",
  看空: "Шорт",
  当前持有: "Текуща позиция",
  胜率: "Процент на успех",
  "盈利/亏损数": "Брой транзакции с печалба/загуба",
  累计实现盈亏: "Реализирана обща печалба/загуба",
  秒: "секунди",
  分: "минути",
  小时: "часа",
  周: "седмица",
  下单时间: "Време на поръчка",
  剩余时间: "Оставащо време",
  买入价: "Цена на покупка",
  结算价: "Цена на сетълмент",
  实现盈利: "Реализирана печалба",
  结算时间: "Време на сетълмент",
  期权: "Опция",
  新手教程: "Ръководство за начинаещи",
  我的订单: "Моите поръчки",
  赔率: "Коефициент",
  全部订单: "Всички поръчки",
  持有订单: "Отворени поръчки",
  历史订单: "История на поръчките",
  输入交易额度: "Въведете сума за търговия",
  选择交易周期: "Изберете период на търговия",
  去注册: "Регистрация",
  冻结: "Замразяване",
  期权支出: "Разход за опция",
  期权收入: "Приход от опция",
  用户提现: "Теглене от потребител",
  "是否购买？": "Закупуване на тази опция?",
  购买成功: "Успешно закупуване",
  请签名: "Моля, подпишете се",
  提交签名: "Изпращане на подпис",
  清空签名: "Изчистване на подписа",
  签名审核中: "Подписът се обработва",
  已提交: "Изпратено",
  扫一扫下载APP: "Сканирайте за изтегляне на приложението",
  新手领取大礼包: "Пакет за добре дошли за нови потребители",
  注册实名即送彩金: "Регистрирайте се и се потвърдете, за да получите бонус",
  交易总额: "Общ обем на търговия",
  资产不足: "Недостатъчни активи",
  "Win账户的资产不足，可从资金账户划转至此账户":
    "Недостатъчни активи в WIN сметката. Можете да прехвърлите активи от основната си сметка.",
  Win: "WIN",
  比赛: "Състезание",
  未开始: "Не е започнало",
  赛程: "Програма",
  赛果: "Резултат",
  已结束: "Завършило",
  让球: "Хендикап",
  进球数: "Голове",
  大: "Над",
  小: "Под",
  胜负平: "1X2 (Победа/Равенство/Загуба)",
  和局: "Равенство",
  投注: "Залог",
  下注金额: "Сума на залога",
  下注: "Заложете",
  阵容: "Състав",
  分析: "Анализ",
  输入下注金额: "Въведете сума на залога",
  下注成功: "Успешен залог",
  投注记录: "История на залозите",
  未结算: "Неуреден",
  已结算: "Уреден",
  流水: "Оборот",
  输赢: "Печалба/Загуба",
  赛时: "Време на мача",
  下注时间: "Време на залога",
  足彩竞猜: "Футболен тотализатор",
  查看详情: "Вижте подробности",
  输: "Загуба",
  赢: "Печалба",
  主: "Домакин",
  客: "Гост",
  主胜: "Победа за домакина",
  客胜: "Победа за госта",
  平: "Равенство",
  已延期: "Отложен",
  账号异常: "Аномалия в профила",
  全场独赢: "Цял мач 1X2",
  全场让球: "Цял мач Хендикап",
  全场大小: "Цял мач Над/Под",
  总进球: "Общо голове",
  拍摄照片要求: "Изисквания към снимката",
  标准拍摄: "Стандартна снимка",
  边框缺失: "Липсва рамка",
  照片模糊: "Неясна снимка",
  闪光强烈: "Твърде силна светкавица",
  上传手持证件照: "Качване на снимка с документ в ръка",
  上传证件照: "Качване на снимка на документ",
  换一张: "Нова снимка",
  出生日期: "Дата на раждане",
  请选择出生日期: "Изберете дата на раждане",
  "输入下方正确的图形验证后，获取邮箱验证码进行注册":
    "Въведете кода за потвърждение по-долу, за да получите имейл код за регистрация.",
  "您还剩余*次认证次数，超出次数将无法继续认证":
    "Остават ви още * опита за потвърждение. След този лимит няма да можете да се потвърдите.",
  上半场: "1-во полувреме",
  下半场: "2-ро полувреме",
  独赢: "1X2",
  上半场独赢: "1-во полувреме 1X2",
  下半场独赢: "2-ро полувреме 1X2",
  上半场让球: "1-во полувреме Хендикап",
  下半场让球: "2-ро полувреме Хендикап",
  上半场大小球: "1-во полувреме Над/Под",
  下半场大小球: "2-ро полувреме Над/Под",
  波胆: "Точен резултат",
  上半场波胆: "1-во полувреме Точен резултат",
  下半场波胆: "2-ро полувреме Точен резултат",
  单双: "Нечетен/Четен",
  单: "Нечетен",
  双: "Четен",
  上半场单双: "1-во полувреме Нечетен/Четен",
  下半场单双: "2-ро полувреме Нечетен/Четен",
  上半场总进球: "1-во полувреме Общо голове",
  下半场总进球: "2-ро полувреме Общо голове",
  中场: "Полувреме",
  "注意：手持证件照请按照此示例图在白纸上书写文字并与证件一起拍摄":
    "Забележка: За снимката с документа в ръка, напишете текста на бял лист хартия и го снимайте заедно с документа си, както в примера.",
  "近期发现大量作弊账户，对一批违规账户进行了惩罚。如果有误判为违规账户，请联系在线客服。":
    "Наскоро много измамни профили бяха наказани. Свържете се с поддръжката, ако смятате, че профилът ви е наказан несправедливо.",
  最小下注金额: "Минимален залог",
  参与活动最小下注金额: "Минимален залог за участие в дейността",
  记住密码: "Запомни парола",
  比分: "Резултат",
  "您还未登录，请先登录": "Не сте влезли в профила си. Първо влезте.",
  立即登录: "Вход сега",
  下注限额: "Лимит на залог",
  可赢金额: "Сума, която може да се спечели",
  闪兑详情: "Детайли на бърза обмяна",
  大小球: "Над/Под",
  "由于汇率原因，下注金额和实际下注金额会有误差，请以订单为准。":
    "Поради колебанията на валутния курс, крайната сума на залога може да се различава. Поръчката е обвързваща.",
  开赛时间: "Начален час",
  足球收入: "Приходи от футбол",
  足球支出: "Разходи за футбол",
  活动详情: "Детайли на дейността",
  为世界杯喝彩: "Подкрепете световното първенство",
  我的竞猜: "Моите прогнози",
  "竞猜比赛、有机会瓜分*USDT":
    "Прогнозирайте мачове и спечелете част от * USDT",
  "瓜分*USDT": "Разпределете * USDT",
  距离活动结束还有: "До края на дейността остават:",
  我的门票: "Моите билети",
  竞猜结束时间: "Край на прогнозирането",
  猜比分: "Прогнозиране на резултат",
  "福利派送中，完成任务即可获取门票":
    "Бонусите се раздават. Изпълнете задачи, за да спечелите билети.",
  "完成如下任务，可获对应数量门票的参与竞赛":
    "Изпълнете следните задачи, за да получите съответния брой билети за участие в състезанието.",
  时: "час",
  活动: "Дейност",
  竞猜记录: "История на прогнозите",
  结果: "Резултат",
  任务: "Задача",
  去邀请: "Поканване",
  "每场比赛的比分竞猜，参与竞猜可瓜分$*美金的奖励。":
    "Прогнозирайте резултата на всеки мач и спечелете част от $*.",
  "参与竞猜需要门票，门票可按照平台的任务进行获得。":
    "За прогнозиране е необходим билет. Билети могат да бъдат спечелени чрез изпълнение на задачите на платформата.",
  "竞猜成功后，把竞猜结果的截图发送给客服，客服会把奖金划入您的资金账户，你可以立即提取。":
    "След успешна прогноза, изпратете екранна снимка на поддръжката. Те ще кредитират бонуса в профила ви, който можете незабавно да изтеглите.",
  "禁止任何作弊行为、如果发现作弊行为，奖励无效。":
    "Измамите са забранени. Ако бъдат открити, наградата ще бъде анулирана.",
  "完成任务后，点击咨询客服获得门票。":
    "След изпълнение на задачите, натиснете 'Свържете се с поддръжката', за да получите билети.",
  继续猜: "Продължете с прогнозирането",
  总单数: "Общ брой залози",
  赛事筛选: "Филтър по събитие",
  球队筛选: "Филтър по отбор",
  总金额: "Обща сума",
  总流水: "Общ оборот",
  派奖金额: "Сума на раздадения бонус",
  下注单数: "Брой залози",
  利润: "Печалба",
  更多福利: "Повече бонуси",
  我的奖金: "Моят бонус",
  未认证: "Непотвърден",
  总量: "Общо",
  或: "или",
  模拟交易: "Демо търговия",
  体验账户不可操作: "Не е налично в демо профил",
  世界杯比分竞猜: "Прогнозиране на резултатите от СП",
  "领*USDT起": "Получете от * USDT",
  消息: "Съобщения",
  滚球: "Директни залози",
  是: "Да",
  不是: "Не",
  当前余额: "Текущ баланс",
  KOL招募: "Набиране на KOL",
  本月净输赢: "Нетна печалба/загуба този месец",
  本月佣金: "Комисионна този месец",
  佣金比例: "Процент на комисионна",
  活跃人数: "Активни потребители",
  新增下级: "Нови долни нива",
  登录人数: "Влезли потребители",
  首存人数: "Потребители с първи депозит",
  数据分析: "Анализ на данни",
  人数: "Брой хора",
  新注册存款金额: "Сума на депозитите на нови регистрации",
  老用户存款金额: "Сума на депозитите на съществуващи потребители",
  首存金额: "Сума на първия депозит",
  快捷入口: "Бърз достъп",
  成员管理: "Управление на членове",
  财务报表: "Финансови отчети",
  分红报表: "Отчет за дивиденти",
  订单记录: "История на поръчките",
  VIP专享: "VIP ексклузивно",
  推广工具: "Инструменти за промоция",
  计算规则: "Правила за изчисление",
  账变明细: "Детайли на транзакцията",
  成员: "Членове",
  下级概览: "Преглед на долни нива",
  下级成员总计: "Общо долни нива",
  本月新增: "Нови този месец",
  本月活跃会员: "Активни членове този месец",
  今日活跃会员: "Активни членове днес",
  本月有效活跃: "Ефективно активни този месец",
  活跃成员占比: "Дял на активните членове",
  本月活跃: "Активни този месец",
  今日活跃: "Активни днес",
  下级成员: "Долни нива",
  会员账号: "Профил на член",
  统计时间: "Време на статистиката",
  筛选: "Филтър",
  存款: "Депозит",
  取款: "Теглене",
  总输赢: "Обща печалба/загуба",
  是否有效用户: "Активен потребител?",
  最近登录时间: "Последно влизане",
  否: "Не",
  开始时间: "Начален час",
  结束时间: "Краен час",
  提取: "Теглене",
  总盈亏: "Общ резултат",
  净盈亏: "Нетен резултат",
  分红: "Дивидент",
  概览: "Преглед",
  月度详细数据: "Месечни подробни данни",
  未发放: "Нераздаден",
  活跃用户: "Активни потребители",
  有效新增会员: "Ефективни нови членове",
  冲正后净输赢: "Нетна печалба/загуба след корекция",
  上月结余: "Баланс от предходния месец",
  净输赢: "Нетна печалба/загуба",
  "系统每日新加坡时间1:00更新一次报表":
    "Отчетите се актуализират ежедневно в 01:00 часа сингапурско време.",
  "报表中数据、总输赢、净输赢中正数表示代理方盈利、负数表示代理方亏损":
    "В отчетите положителните числа означават печалба за партньора, отрицателните числа означават загуба за партньора.",
  "佣金数据每天进行更新，仅供参考，并不做实际佣金派发标准":
    "Данните за комисионната се актуализират ежедневно, те са ориентировъчни и не представляват окончателна основа за изплащане.",
  选择时间: "Избор на време",
  足球: "Футбол",
  投注金额: "Сума на залога",
  有效订单: "Валидни поръчки",
  下级账户: "Профил на долно ниво",
  待成交: "В изчакване",
  下单金额: "Сума на поръчката",
  订单内容: "Съдържание на поръчката",
  秒数: "Секунди",
  联赛: "Лига",
  队伍: "Отбор",
  比赛时间: "Време на мача",
  玩法: "Тип залог",
  等级规则表: "Таблица на правилата за нива",
  等级: "Ниво",
  活跃会员: "Активни членове",
  最新活跃: "Последна активност",
  额外佣金: "Допълнителна комисионна",
  "每月按照对应等级的增长标准与奖励制度执行，只可享受一个等级奖励。":
    "Месечно въз основа на стандартите за растеж. Можете да се възползвате само от едно ниво.",
  渠道生成: "Генериране на канал",
  创建: "Създаване",
  渠道名称: "Име на канала",
  注册人数: "Брой регистрации",
  浏览人数: "Брой прегледи",
  构建状态: "Състояние на изграждане",
  禁用: "Деактивиране",
  启用: "Активиране",
  查看: "Преглед",
  创建渠道: "Създаване на канал",
  创建成功: "Успешно създаване",
  操作成功: "Успешно действие",
  渠道详情: "Детайли на канала",
  邀请码: "Код за покана",
  访问人数: "Брой посетители",
  渠道地址: "Адрес на канала",
  我的福利: "Моите бонуси",
  充值福利: "Бонус за депозит",
  当前流水: "Текущ оборот",
  如何参与: "Как да участвам",
  币种充值: "Депозит на криптовалута",
  充值福利中领取福利: "Получаване на бонус в бонуса за депозит",
  "规则：充值福利自愿领取，有效期为充值后的24小时内，过期无效，领取后将暂时锁定提现功能，当流水达到后即可解锁提现。":
    "Правило: Бонусът за депозит е доброволен, валиден 24 часа след депозиране. След получаване, тегленето ще бъде временно блокирано, докато не бъде изпълнено изискването за оборот.",
  失效日期: "Дата на изтичане",
  "暂无福利领取，充值后领取": "Няма наличен бонус. Получете след депозит.",
  参与: "Участие",
  充值赠送: "Бонус за депозит",
  "领取*%的赠送": "Получаване на *% бонус",
  去领取: "Получаване",
  VIP奖励: "VIP награда",
  "当前可领取*USDT，是否确认领取":
    "* USDT са налични за получаване. Потвърждение?",
  "领取后将临时锁定提现功能，当您的流水到达*USDT后即可解除锁定":
    "След получаване, тегленето ще бъде временно блокирано, докато не бъде достигнат оборот от * USDT.",
  充值送大礼: "Подарък за депозит",
  "存入越多，送越多！": "Колкото повече депозирате, толкова по-голям подарък!",
  无效: "Невалиден",
  有效: "Валиден",
  总存金额: "Обща депозирана сума",
  提示: "Забележка",
  "总输赢，净输赢中正数表示平台盈利，负数表示亏损，每天数据只做参考，并不做实际佣金派发标准。":
    "Положителните числа в общата и нетната печалба/загуба означават печалба на платформата. Дневните данни са ориентировъчни.",
  "净盈亏：总盈亏-用户返水":
    "Нетен резултат: Общ резултат - Възстановяване на потребителя",
  盈利方: "Страна с печалба",
  代理: "Агент",
  客户: "Клиент",
  平局: "Равенство",
  平台: "Платформа",
  "已提交审核，请耐心等待": "Изпратено за проверка. Моля изчакайте.",
  充值日期: "Дата на депозит",
  平台本月总输赢: "Обща печалба/загуба на платформата този месец",
  KOL招募合作: "Сътрудничество за набиране на KOL",
  "平台现在开放【KOL招募活动】，只要您有社群媒体号，就可以和平台享受分红一次性推广客户，就可以享受终生收益。":
    "Платформата отваря набиране на KOL. С профил в социалните медии можете да се насладите на дивиденти и пожизнен доход чрез еднократно привличане на клиенти.",
  级别: "Ниво",
  平台利润返佣: "Комисионна от печалбата на платформата",
  佣金案例: "Пример за комисионна",
  交易项目: "Продукти за търговия",
  "期权交易、合约交易、足球游戏":
    "Търговия с опции, търговия с фючърси, футболни игри",
  报名方式: "Начин на записване",
  点击KOL招募报名: "Натиснете, за да се запишете за набиране на KOL",
  "欢迎加入我们的团队，平台全面扶持您建立属于自己的用户体系，最高可得*的佣金，我们期待您加入。":
    "Добре дошли в нашия екип. Ние ви подкрепяме в изграждането на ваша собствена потребителска система. Спечелете до *% комисионна. Очакваме вашето участие.",
  输入联系方式: "Въведете данни за контакт",
  最低活跃人数: "Минимален брой активни потребители",
  "如：本月活跃人数≥*并且本月平台总输赢≥*USDT，您属于等级*，即可得到*%的佣金。":
    "Например: Ако активните потребители този месец ≥ * и общата печалба/загуба на платформата ≥ * USDT, вие принадлежите към ниво * и получавате *% комисионна.",
  比分竞猜: "Прогнозиране на резултат",
  豪礼相赠: "Голям подарък",
  足球活动: "Футболна дейност",
  圣诞节活动: "Коледна дейност",
  "您参加了活动，临时锁定提现功能，还需*USDT流水就可以解除锁定。":
    "Участвали сте в дейност. Тегленето е временно блокирано. Необходими са ви още * USDT оборот, за да отключите.",
  剩余流水: "Оставащ оборот",
  助力足球: "Подкрепа на футбола",
  佣金累计: "Обща комисионна",
  有效投注: "Валидни залози",
  今日: "Днес",
  今日返水: "Възстановяване днес",
  VIP返水: "VIP възстановяване",
  返水记录: "История на възстановяванията",
  成员信息: "Информация за члена",
  基本信息: "Основна информация",
  钱包余额: "Баланс на портфейла",
  投注信息: "Информация за залога",
  返水: "Възстановяване",
  总下注: "Общ залог",
  今日输赢: "Печалба/загуба днес",
  下注动态: "Активност на залозите",
  返水奖励: "Награда за възстановяване",
  分红金额: "Сума на дивидента",
  返水支出: "Разход за възстановяване",
  总返水: "Общо възстановяване",
  流水总额: "Общ оборот",
  返水总额: "Общо възстановяване",
  返水详情: "Детайли на възстановяването",
  日流水: "Дневен оборот",
  "平台根据你下级每日流水进行额外返水奖励,奖励每日新加坡时间00：00进行派发至赏金账户":
    "Платформата предоставя допълнително възстановяване въз основа на дневния оборот на вашите долни нива. Изплащането се извършва ежедневно в 00:00 часа сингапурско време в бонус профила.",
  "申请成功，等待审核": "Заявката е успешна, в очакване на проверка",
  "我出本金，盈利共分享": "Аз давам капитала, печалбата се споделя",
  最高分红: "Максимален дивидент",
  投资大师比赛: "Състезание Майстор инвеститор",
  "我出本金，你盈利": "Аз давам капитала, ти печелиш",
  共分享: "Споделяне заедно",
  最高分红可得: "Максимален възможен дивидент",
  "新用户专属福利来袭，免费赠送$*，领取后即可投资平台任何项目，盈利后立即可提取。":
    "Ексклузивен бонус за добре дошли: $* безплатно. След получаване можете да инвестирате във всеки проект. Печалбата може незабавно да бъде изтеглена.",
  报名领取: "Запишете се и получете",
  审核驳回: "Проверката е отказана",
  驳回原因: "Причина за отказа",
  活动运行周期: "Период на провеждане на дейността",
  "申请成功后起至*天内完成超额收益。":
    "Постигнете свръхдоходност в рамките на * дни от одобрението.",
  分红比: "Коефициент на дивидент",
  "*日获得盈利后，可获得*%的收益额。":
    "След постигане на печалба на ден *, получавате *% от сумата на доходността.",
  参与条件: "Условия за участие",
  "俄罗斯、土耳其地区的用户，且未参与。":
    "Потребители от Русия или Турция, които все още не са участвали.",
  计算项目: "Изчислени продукти",
  "合约、体育、期权": "Фючърси, Спорт, Опции",
  我的投资: "Моите инвестиции",
  参与天数: "Дни на участие",
  累计下注: "Общ залог",
  累计盈亏: "Обща печалба/загуба",
  预计可分红: "Очакван дивидент",
  常见问题: "Често задавани въпроси (FAQ)",
  什么是平台出资: "Какво е финансиране от платформата?",
  "平台根据部分国家的用户，免费提供资金让用户去投项目。":
    "Платформата предоставя безплатни средства на потребители от определени държави, за да инвестират в проекти.",
  怎么获取平台出资的福利: "Как да получа бонуса за финансиране от платформата?",
  "您是指定国家的用户即可，点击上方报名按钮，当平台审核完成后将会把*USDT转入当前账户下的赏金账户，您可划转至其他账户下进行投资。":
    "Ако сте от една от определените държави, натиснете бутона за записване. След одобрение, * USDT ще бъдат прехвърлени към вашия бонус профил, който можете да прехвърлите, за да инвестирате.",
  什么是分红: "Какво е дивидент?",
  "分红指在规定时间内，收益额到达100%后，可分得超额收益的50%。例如：领取100USDT资金，收益额度是120%。":
    "Дивидент: Ако доходността достигне 100% в определения срок, получавате 50% от свръхдоходността. Пример: Получавате 100 USDT, постигате 120% доходност, тогава 20% е свръхдоходност.",
  "如何取得分红？": "Как да получа дивидент?",
  "活动周期每*天1次，活动结束后进行核算，满足活动要求后分红派发至赏金账户。若你未达到活动要求，系统将自动清除你的收益额和平台的出资。":
    "Цикълът на дейността е веднъж на всеки * дни. След приключване се извършва сетълмент. Ако изпълните изискванията, дивидентът се изпраща в бонус профила. Ако не, вашата доходност и финансирането от платформата ще бъдат премахнати.",
  "参与的账号需进行KYC认证，每个账户仅限一份福利。":
    "Участващите профили трябва да бъдат KYC потвърдени. Само един бонус на профил.",
  "参与账号的KYC需要指定的国家方可参与，其他地区无权限参与，请核对活动国家与您的国家是否一致。":
    "KYC за участие е валиден само за определени държави. Проверете дали вашата държава съвпада с държавата на дейността.",
  "参与活动成功后，账户将临时锁定您的提现功能，当完成活动后即可解除您的提现功能。":
    "След успешно участие, тегленето ще бъде временно блокирано до приключване на дейността.",
  "请遵守平台活动规则，若发现作弊、利用系统漏洞进行获利，平台将会长期冻结您的账户下所有资金。":
    "Спазвайте правилата на дейността. При измама или злоупотреба със системни грешки, всички средства в профила ви ще бъдат окончателно замразени.",
  平台出资: "Финансиране от платформата",
  平台出资收回: "Финансиране от платформата оттеглено",
  投资大师奖励: "Награда Майстор инвеститор",
  请下载APP添加收款方式:
    "Изтеглете приложението, за да добавите метод за получаване",
  请下载APP进行身份验证:
    "Изтеглете приложението, за да извършите потвърждение на самоличността",
  请下载APP参与: "Изтеглете приложението, за да участвате",
  技术指标: "Технически индикатори",
  主图: "Основна графика",
  副图: "Вторична графика",
  新注册人数: "Нови регистрации",
  老用户存款人数: "Съществуващи потребители, които депозират",
  存款人数: "Брой депозити",
  取款人数: "Брой тегления",
  投注人数: "Брой залози",
  "除印度尼西亚、印度、孟加拉国，且未参与过的用户。":
    "С изключение на потребители от Индонезия, Индия, Бангладеш, които все още не са участвали.",
  市场动态: "Пазарна динамика",
  外汇合约: "Фючърси на валутния пазар",
  盈亏比: "Съотношение печалба/загуба",
  委托价: "Цена на поръчката",
  可用余额: "Наличен баланс",
  持仓额: "Стойност на позицията",
  强平价: "Цена на ликвидация",
  修改: "Промяна",
  修改价位: "Промяна на цената",
  外汇: "Форекс",
  外汇账户: "Форекс профил",
  我的交易: "Моите транзакции",
  未设置: "Не е зададено",
  超出最大可设数值:
    "Превишава максималната стойност, която може да бъде зададена",
  超出最小可设数值: "Под минималната стойност, която може да бъде зададена",
  止盈超出最小可设数值:
    "Тейк-профит под минималната стойност, която може да бъде зададена",
  止损超出最大可设数值:
    "Стоп-лос превишава максималната стойност, която може да бъде зададена",
  止盈超出最大可设数值:
    "Тейк-профит превишава максималната стойност, която може да бъде зададена",
  止损超出最小可设数值:
    "Стоп-лос под минималната стойност, която може да бъде зададена",
  挖矿: "Копаене",
  交易账户: "Търговски профил",
  买涨: "Купуване (Лонг)",
  买跌: "Продаване (Шорт)",
  请输入正确的银行卡信息: "Въведете правилните данни за банкова карта",
  联系在线客服: "Свържете се с онлайн поддръжката",
  法币交易请联系在线客服: "Свържете се с поддръжката за фиат търговия",
  提交订单: "Изпращане на поръчка",
  "支付过程如有疑问,请联系在线客服":
    "Свържете се с поддръжката, ако имате въпроси относно процеса на плащане",
  彩金赠送: "Предоставяне на бонус",
  在线客服: "Онлайн чат",
  最少投资: "Минимална инвестиция",
  "提交时间:": "Време на изпращане:",
  提现拒绝: "Тегленето отказано",
  认证拒绝: "Потвърждението отказано",
  认证通过: "Потвърждението одобрено",
  请输入正确的交易额度: "Въведете валидна сума за търговия",
  最大下注金额: "Максимален залог",
  手机号: "Телефонен номер",
  邮箱注册: "Регистрация с имейл",
  手机号注册: "Регистрация с телефонен номер",
  查询: "Заявка",
  手机号登录: "Вход с телефонен номер",
  邮箱登录: "Вход с имейл",
  请输入数量: "Въведете количество",
  可用数量: "Налично количество",
  钱包登录: "Вход с портфейл",
  请输入正确的邀请码: "Въведете валиден код за покана",
  "请输入邀请码(必填)": "Въведете код за покана (задължително)",
  输入正确的金额: "Въведете валидна сума",
  法币充值: "Фиат депозит",
  卢比充值: "Депозит в индийски рупии",
  请输入法币: "Въведете фиат сума",
  请输入IFSC: "Въведете IFSC код",
  "银行编码(选填)": "Банков код (по избор)",
  请输入银行编码: "Въведете банков код",
  请输入大于8位数的密码: "Въведете парола с повече от 8 знака",
  添加成功: "Успешно добавяне",
  "60秒": "60 секунди",
  "180秒": "180 секунди",
  "300秒": "300 секунди",
  "2次密码不一致": "Паролите не съвпадат",
  输入提币数量: "Въведете количество за теглене",
  图片格式不正确: "Невалиден формат на изображението",
  图片大于20M: "Изображението е по-голямо от 20 MB",
  请设置委托价格: "Задайте цена на поръчката",
  输入资金密码: "Въведете парола за активите",
  验证码错误: "Грешен код за потвърждение",
  充值拒绝: "Депозитът отказан",
  请输入SSN: "Въведете SSN",
  结算完成: "Сетълментът завършен",
  继续下单: "Продължаване на поръчката",
  限价: "Лимитирана поръчка",
  买入价格: "Цена на покупка",
  买入量: "Количество за покупка",
  卖出价格: "Цена на продажба",
  卖出量: "Количество за продажба",
  买入: "Купуване",
  卖出: "Продаване",
  订单创建成功: "Поръчката е създадена успешно",
  币币买入支出: "Разход за спот покупка",
  币币买入支出退还: "Възстановяване на разход за спот покупка",
  币币买入获得: "Получено от спот покупка",
  币币卖出支出: "Разход за спот продажба",
  币币卖出支出退还: "Възстановяване на разход за спот продажба",
  币币卖出获得: "Получено от спот продажба",
  币币交易手续费: "Такса за спот транзакция",
  请输入限价: "Въведете лимитирана цена",
  成交: "Изпълнено",
  等待成交: "В очакване на изпълнение",
  交易完成: "Транзакцията завършена",
  被取消: "Отменено",
  交易时间: "Време на транзакция",
  法币交易: "Фиат транзакция",
  法币出售: "Фиат продажба",

  两次密码不一致: "Паролите не съвпадат",
  再次输入账户密码: "Въведете отново паролата на профила",

  美国: "Съединени щати",
  韩国: "Южна Корея",
  阿尔巴尼亚: "Албания",
  津巴布韦: "Зимбабве",
  赞比亚: "Замбия",
  也门: "Йемен",
  美属维尔京群岛: "Американски Вирджински острови",
  英属处女群岛: "Британски Вирджински острови",
  越南: "Виетнам",
  委内瑞拉: "Венецуела",
  瓦努阿图: "Вануату",
  乌兹别克斯坦: "Узбекистан",
  乌拉圭: "Уругвай",
  英国: "Обединено кралство",
  阿拉伯联合酋长国: "Обединени арабски емирства",
  乌克兰: "Украйна",
  乌干达: "Уганда",
  特克斯和凯科斯群岛: "Търкс и Кайкос",
  土库曼斯坦: "Туркменистан",
  土耳其: "Турция",
  突尼斯: "Тунис",
  特立尼达和多巴哥: "Тринидад и Тобаго",
  汤加: "Тонга",
  多哥: "Того",
  东帝汶: "Източен Тимор",
  泰国: "Тайланд",
  坦桑尼亚: "Танзания",
  塔吉克斯坦: "Таджикистан",
  中国台湾: "Тайван",
  叙利亚: "Сирия",
  瑞士: "Швейцария",
  瑞典: "Швеция",
  斯威士兰: "Есватини",
  苏里南: "Суринам",
  苏丹: "Судан",
  斯里兰卡: "Шри Ланка",
  西班牙: "Испания",
  南非: "Южна Африка",
  索马里: "Сомалия",
  所罗门群岛: "Соломонови острови",
  斯洛文尼亚: "Словения",
  斯洛伐克: "Словакия",
  "圣马丁岛（荷兰部分）": "Синт Мартен (холандска част)",
  新加坡: "Сингапур",
  塞拉利昂: "Сиера Леоне",
  塞舌尔: "Сейшели",
  塞尔维亚: "Сърбия",
  塞内加尔: "Сенегал",
  沙特阿拉伯: "Саудитска Арабия",
  圣多美和普林西比: "Сао Томе и Принсипи",
  圣马力诺: "Сан Марино",
  萨摩亚: "Самоа",
  圣克里斯托弗和尼维斯: "Сейнт Китс и Невис",
  圣文森特和格林纳丁斯: "Сейнт Винсент и Гренадини",
  圣彼埃尔和密克隆岛: "Сен Пиер и Микелон",
  圣露西亚: "Сейнт Лусия",
  圣基茨和尼维斯: "Сейнт Китс и Невис",
  卢旺达: "Руанда",
  俄罗斯: "Русия",
  罗马尼亚: "Румъния",
  留尼汪: "Реюнион",
  刚果共和国: "Република Конго",
  卡塔尔: "Катар",
  波多黎各: "Пуерто Рико",
  葡萄牙: "Португалия",
  波兰: "Полша",
  菲律宾: "Филипини",
  秘鲁: "Перу",
  巴拉圭: "Парагвай",
  巴布亚新几内亚: "Папуа Нова Гвинея",
  巴拿马: "Панама",
  巴勒斯坦: "Палестина",
  帕劳: "Палау",
  巴基斯坦: "Пакистан",
  阿曼: "Оман",
  挪威: "Норвегия",
  尼日利亚: "Нигерия",
  尼日尔: "Нигер",
  尼加拉瓜: "Никарагуа",
  新西兰: "Нова Зеландия",
  新喀里多尼亚: "Нова Каледония",
  荷属安德列斯群岛: "Холандски Антили",
  荷兰: "Нидерландия",
  尼泊尔: "Непал",
  纳米比亚: "Намибия",
  缅甸: "Мианмар",
  莫桑比克: "Мозамбик",
  摩洛哥: "Мароко",
  蒙特塞拉特岛: "Монтсерат",
  黑山: "Черна гора",
  蒙古: "Монголия",
  摩纳哥: "Монако",
  摩尔多瓦: "Молдова",
  墨西哥: "Мексико",
  马约特: "Майот",
  毛里求斯: "Мавриций",
  毛里塔尼亚: "Мавритания",
  马里亚纳群岛: "Мариански острови",
  马提尼克: "Мартиника",
  马耳他: "Малта",
  马里: "Мали",
  马尔代夫: "Малдиви",
  马来西亚: "Малайзия",
  马拉维: "Малави",
  马达加斯加: "Мадагаскар",
  马其顿: "Северна Македония",
  中国澳门: "Макао",
  卢森堡: "Люксембург",
  立陶宛: "Литва",
  列支敦士登: "Лихтенщайн",
  利比亚: "Либия",
  利比里亚: "Либерия",
  莱索托: "Лесото",
  黎巴嫩: "Ливан",
  拉脱维亚: "Латвия",
  老挝: "Лаос",
  吉尔吉斯斯坦: "Киргизстан",
  科威特: "Кувейт",
  基里巴斯: "Кирибати",
  肯尼亚: "Кения",
  哈萨克斯坦: "Казахстан",
  约旦: "Йордания",
  日本: "Япония",
  牙买加: "Ямайка",
  象牙海岸: "Кот д'Ивоар",
  意大利: "Италия",
  以色列: "Израел",
  爱尔兰: "Ирландия",
  伊拉克: "Ирак",
  伊朗: "Иран",
  印度尼西亚: "Индонезия",
  印度: "Индия",
  冰岛: "Исландия",
  匈牙利: "Унгария",
  中国香港: "Хонконг",
  洪都拉斯: "Хондурас",
  海地: "Хаити",
  圭亚那: "Гвиана",
  几内亚比绍共和国: "Гвинея-Бисау",
  几内亚: "Гвинея",
  危地马拉: "Гватемала",
  关岛: "Гуам",
  瓜德罗普岛: "Гваделупа",
  格林纳达: "Гренада",
  格陵兰岛: "Гренландия",
  希腊: "Гърция",
  直布罗陀: "Гибралтар",
  加纳: "Гана",
  德国: "Германия",
  格鲁吉亚: "Грузия",
  冈比亚: "Гамбия",
  加蓬: "Габон",
  法属波利尼西亚: "Френска Полинезия",
  法属圭亚那: "Френска Гвиана",
  法国: "Франция",
  芬兰: "Финландия",
  斐济: "Фиджи",
  法罗群岛: "Фарьорски острови",
  埃塞俄比亚: "Етиопия",
  爱沙尼亚: "Естония",
  厄立特里亚: "Еритрея",
  赤道几内亚: "Екваториална Гвинея",
  萨尔瓦多: "Салвадор",
  埃及: "Египет",
  厄瓜多尔: "Еквадор",
  多米尼加共和国: "Доминиканска република",
  多米尼加: "Доминика",
  吉布提: "Джибути",
  丹麦: "Дания",
  捷克: "Чехия",
  塞浦路斯: "Кипър",
  库拉索: "Кюрасао",
  古巴: "Куба",
  克罗地亚: "Хърватия",
  哥斯达黎加: "Коста Рика",
  科特迪瓦: "Кот д'Ивоар",
  库克群岛: "Острови Кук",
  科摩罗: "Коморски острови",
  哥伦比亚: "Колумбия",
  智利: "Чили",
  乍得: "Чад",
  中非共和国: "Централноафриканска република",
  佛得角: "Кабо Верде",
  开曼群岛: "Кайманови острови",
  开普: "Кейп",
  加拿大: "Канада",
  喀麦隆: "Камерун",
  柬埔寨: "Камбоджа",
  布隆迪: "Бурунди",
  布基纳法索: "Буркина Фасо",
  保加利亚: "България",
  文莱: "Бруней",
  巴西: "Бразилия",
  博茨瓦纳: "Ботсвана",
  波斯尼亚和黑塞哥维那: "Босна и Херцеговина",
  玻利维亚: "Боливия",
  不丹: "Бутан",
  百慕大群岛: "Бермудски острови",
  贝宁: "Бенин",
  伯利兹: "Белиз",
  比利时: "Белгия",
  白俄罗斯: "Беларус",
  巴巴多斯: "Барбадос",
  孟加拉国: "Бангладеш",
  巴林: "Бахрейн",
  巴哈马: "Бахамски острови",
  阿塞拜疆: "Азербайджан",
  奥地利: "Австрия",
  澳大利亚: "Австралия",
  阿鲁巴: "Аруба",
  亚美尼亚: "Армения",
  阿根廷: "Аржентина",
  安提瓜和巴布达: "Антигуа и Барбуда",
  安圭拉: "Ангуила",
  安哥拉: "Ангола",
  安道尔: "Андора",
  美属萨摩亚: "Американска Самоа",
  阿尔及利亚: "Алжир",
  中国: "Китай",
  余额不足: "Недостатъчен баланс",
  最低购买: "Минимална покупка",
  最高购买: "Максимална покупка",
  下单成功: "Поръчката е изпратена успешно",
  平仓成功: "Позицията е затворена успешно",
  请输入正确的平仓数量: "Въведете валидно количество за затваряне",
  加仓成功: "Позицията е увеличена успешно",
  请输入正确的加仓金额: "Въведете валидна сума за увеличаване на позицията",
  收藏成功: "Добавено към любими",
  取消收藏成功: "Премахнато от любими",
  加密币永续: "Перпетуал на криптовалута",
  外汇永续: "Перпетуал на форекс",
  期权账户: "Профил за опции",
  快捷卖币: "Бърза продажба на криптовалута",

  托管资金: "Управлявани средства",
  托管中: "В управление",
  预计日收益: "Очаквана дневна доходност",
  累计收益: "Обща доходност",
  周期: "Продължителност",
  日收益: "Дневна доходност",
  限额: "Лимит",
  立即托管: "Стартиране на управление сега",
  "已鎖定 請聯繫客服": "Заключено. Свържете се с поддръжката.",
  产品列表: "Списък на продуктите",
  规则: "Правила",
  创建订单: "Създаване на поръчка",
  产品名称: "Име на продукта",
  托管周期: "Период на управление",
  等级限制: "Ограничение на ниво",
  托管金额: "Управлявана сума",
  限额: "Лимит",
  余额: "Баланс",
  购买日: "Дата на покупка",
  起息日: "Начало на олихвяване",
  派息时间: "Време на изплащане на лихва",
  每天: "Ежедневно",
  计息结束日: "Крайна дата на олихвяване",
  每日收益: "Дневна доходност",
  预计收益: "Очаквана доходност",
  "收益将自动发送至您的余额账户;":
    "Доходността ще бъде автоматично изпратена към баланса на вашия профил;",
  "您的资金没有任何风险;": "Вашите средства не са изложени на риск;",
  "365*24小时不断地工作;": "Работи 24/7, 365 дни в годината;",
  托管中: "В управление",
  结束: "Завършено",
  今日收益: "Днешна доходност",
  剩余周期: "Оставащ срок",
  进行中: "Активен",
  已发放: "Изплатено",
  信誉分: "Точки на репутация",

  复制成功: "Копирането е успешно",
  VIP权益: "VIP предимства",
  旧密码: "Стара парола",
  请输入旧密码: "Моля, въведете старата парола",
  "忘记旧密码请联系客服重置。":
    "Ако сте забравили старата парола, моля, свържете се с обслужването на клиенти, за да я нулирате.",
  去升级: "Надграждане",
  描述: "Описание",
  实际存款金额: "Реална сума на депозита",
  升级礼金: "Бонус за надграждане",
  隔夜利息: "Лихва за овърнайт",
  自动结算: "Автоматично сетълмент",
  等级规则: "Правила за нивата",
  "WEB3.0币持有数据收益": "Доходност от данни за притежаване на WEB3.0 монети",
  总生产: "Общо производство",
  有效节点: "Активни възли",
  参与人: "Участници",
  用户收益: "Потребителска доходност",
  "流动性WEB3.0输出": "Изход на ликвидност WEB3.0",
  总资产: "Общо активи",

  ETHAI持有数据收益: "Доход от притежаване на ETHAI",
  AI量化流动性: "AI количествена ликвидност",
  现货买入手续费: "Такса за закупуване на спот",
  现货支出: "Спот разход",
  现货资金费率: "Спот лихвен процент по финансиране",
  现货卖出手续费: "Такса за продажба на спот",
  现货收入: "Спот приход",
  外汇合约支出: "Разход за валутен фючърсен договор",
  外汇合约买入手续费: "Такса за закупуване на валутен фючърсен договор",
  外汇合约资金费率: "Лихвен процент по финансиране на валутен фючърсен договор",
  外汇合约卖出手续费: "Такса за продажба на валутен фючърсен договор",
  外汇合约收入: "Приход от валутен фючърсен договор",
  理财购买: "Закупуване на инвестиционен продукт",
  VIP理财日收益: "Дневен доход от VIP инвестиционен продукт",
  VIP理财隔夜利息: "Лихва за овърнайт на VIP инвестиционен продукт",
  VIP本金返还: "Възстановяване на главницата за VIP",
  VIP彩金发放: "Изплащане на VIP бонус",
  VIP彩金抵扣: "VIP приспадане на бонус",
  隔夜利息: "Лихва за овърнайт",
  设置资产密码: "Задаване на парола за активите",

  锁仓挖矿: "Заключено копаене",
  一站式理财服务: "Цялостна финансова услуга",
  产品: "Продукти",
  客服中心: "Център за обслужване на клиенти",
  贷款: "Заеми",
  挖矿赚不停: "Печелете непрекъснато от копаене",
  "锁仓挖矿是通过将USDT (USD:1USDT=1USD) 托管给平台超算力矿机，在平台矿池中进行挖矿收益。":
    "Заключеното копаене се осъществява чрез поверяване на USDT (USD:1USDT=1USD) на суперизчислителните копачни машини на платформата за получаване на доходи от копаене в копачния пул на платформата.",
  产品优势: "Предимства на продукта",
  随存随取: "Свободно депозиране и теглене",
  锁仓周期: "Период на заключване",
  每日下发: "Ежедневно разпределение",
  随机空投: "Случаен еърдроп",
  "100%资金安全保障": "100% гаранция за сигурност на средствата",
  "100%节假日收益不间断": "100% непрекъснати приходи дори по празници",
  成功锁仓后当天产出: "Доходът започва още в деня на успешното заключване",
  关于违约金: "Относно неустойката",
  "若您希望转出未到期的本金,则会产生违约金,违约金=违约结算比例*剩余天数*锁仓金额.":
    "Ако желаете да изтеглите главницата преди падежа, ще бъде начислена неустойка. Неустойка = процент на неустойка × оставащи дни × сума на заключването.",
  "举例:此锁仓挖矿的违约结算比例为5%,剩余3天到期,锁仓金额为10000U《USDT/USD》,则违约金=5%*3*10000=1500U,实际退回本金为15000U-1500U":
    "Пример: Процентът на неустойката за това заключено копаене е 5%, остават 3 дни до падежа, а заключената сума е 10000U (USDT/USD). Тогава неустойката е 5%×3×10000=1500U, а реално върнатата главница е 15000U-1500U.",
  收益计算: "Изчисляване на дохода",
  "平台有多种锁仓挖矿理财产品供使用者选择,收益计算如下,举例:":
    "Платформата предлага различни финансови продукти за заключено копаене. Изчисляването на дохода е както следва, например:",
  "会员在平台锁仓10000U(USDT,USD),如选择了周期为7天,日产出为锁仓金额的0.7%~1.8%的理财产品,则每天产出如下":
    "Ако потребител заключи 10000U (USDT, USD) на платформата и избере 7-дневен финансов продукт с дневна доходност от 0.7%~1.8% от заключената сума, тогава дневният доход е следният:",
  "最低:10000Ux0.7%=70U;": "Минимум: 10000U×0.7%=70U;",
  "最高:10000Ux1.8%=180U;": "Максимум: 10000U×1.8%=180U;",
  "即7天后可获得490U~1260U的收益,收益每日下发,锁仓本金到期后,自动转入您的资金账户.":
    "След 7 дни могат да бъдат получени приходи от 490U~1260U. Доходите се разпределят ежедневно, а заключената главница автоматично се превежда във вашата финансова сметка след изтичане на периода.",
  正在托管的资金: "Средства под управление",
  签到: "Чекиране",
  锁仓订单: "Поръчки за заключване",
  预计今日收益: "Очакван доход за днес",
  累计收益: "Натрупан доход",
  托管中的订单: "Поръчки под управление",
  单笔最少: "Минимална сума на поръчка",
  单笔最多: "Максимална сума на поръчка",
  日收益率: "Дневна доходност",
  说明: "Описание",
  "1.数据统计时间以GMT+8时间为准<br>2.每日收益值以GMT+8当天时间00:00-23:59点(本地时间00:00-23:59)的所有已结算订单为基准计算得出<br>3.当天的收益会统一在次日GMT+8时间00:00-00:10内派发.":
    "1. Времето за статистика е според GMT+8<br>2. Дневният доход се изчислява въз основа на всички приключени поръчки между 00:00-23:59 GMT+8 (местно време 00:00-23:59)<br>3. Приходите за деня се разпределят на следващия ден между 00:00-00:10 GMT+8.",
  知道了: "Разбрах",
  锁仓: "Заключване",
  派息时间: "Време за изплащане",
  每日: "Ежедневно",
  托管资金: "Управлявани средства",
  到期返回: "Връщане при падеж",
  提前赎回: "Предсрочно обратно изкупуване",
  预计收益: "Очакван доход",
  认购: "Абониране",
  热门: "Популярни",
  数字货币: "Дигитални валути",
  贵金属: "Благородни метали",
  大宗商品: "Суровини",
  持仓明细: "Детайли за позициите",
  历史明细: "Исторически записи",
  当前价: "Текуща цена",
  "↑买涨": "↑ Покупка при покачване",
  "↓买跌": "↓ Покупка при спад",
  显示全部: "Покажи всички",
  买入金额: "Сума за покупка",
  方向: "Посока",
  收益: "Доход",
  预期收益: "Очакван доход",
  估用保证金: "Очакван маржин",
  确认下单: "Потвърди поръчката",
  锁定: "Заключено",
  账户总资产: "Общи активи на сметката",
  明细: "Детайли",
  今日收益: "Днешен доход",
  仓位保证金: "Маржин на позицията",
  持有仓位: "Отворени позиции",
  "锁定金额=所有锁仓挖矿中未完成订单的金额总和":
    "Заключена сума = общата сума на всички незавършени поръчки за заключено копаене",
  "1.数据统计时间以GMT+8时间为准<br>2.每日收益值以GMT+8当天时间00:00-23:59点(本地时间00:00-23:59)的所有已结算订单为基准计算得出":
    "1. Времето за статистика е според GMT+8<br>2. Дневният доход се изчислява въз основа на всички приключени поръчки между 00:00-23:59 GMT+8 (местно време 00:00-23:59)",
  充值方式: "Метод за депозит",
  银行汇款: "Банков превод",
  "银行汇款请联系客服进行操作!":
    "Моля, свържете се с обслужването на клиенти за банков превод!",
  提款方式: "Метод за теглене",
  "银行提款请联系客服进行操作!":
    "Моля, свържете се с обслужването на клиенти за банково теглене!",
  资金明细: "Детайли за средствата",
  提现记录: "История на тегленията",
  拒绝: "Отказано",
  通过: "Одобрено",
  拒绝原因: "Причина за отказ",

  消息公告: "Съобщения",
  订单: "Поръчки",
  个人中心: "Личен център",
  "未到期赎回需支付一定的违约金!":
    "При предсрочно изтегляне се заплаща неустойка.",

  请输入区号: "Моля, въведете кода на областта",
  "请选择国家/地区": "Моля, изберете държава/регион",

  今日开盘: "Отваряне днес",
  昨日收盘: "Вчерашно затваряне",

  实名认证即送: "Получете веднага след потвърждаване на самоличността",
  立即认证: "Потвърдете сега",
  新用户礼包: "Подаръчен пакет за нови потребители",
  完成新人任务领取: "Изпълнете задачите за нови потребители, за да го получите",
  认证: "Потвърждаване",
  时间周期: "Период",
  支付金额: "Сума на плащането",
  已平仓: "Затворена позиция",
  "MGBX 新用户欢迎礼包：每位用户最多可获得":
    "Приветствен пакет MGBX за нови потребители: Всеки потребител може да получи максимум",
  我已经阅读并同意: "Прочетох и съм съгласен/съгласна с",
  隐私政策: "Политика за поверителност",

  放弃奖励离开: "Откажете се от наградата и напуснете",
  继续注册: "Продължете регистрацията",
  分钟: "Минути",
  "请先勾选隐私政策!": "Моля, първо прегледайте Политиката за поверителност!",
  添加其他到自选: "Добавяне на други към списъка за наблюдение",
  充值最高可得: "Зареди сметката си и вземи до 30 000 долара.",

  请输入格式正确的手机号: "Моля, въведете валиден номер на мобилен телефон.",
  收起: "Collapse",
  上传截图: "Upload screenshot",
  "*充值成功后必须上传充值截图，否则将视为无效存款。": "*After a successful recharge, you must upload the recharge screenshot; otherwise the deposit will be invalid.",
};
// 保加利亚语



// WEBPACK FOOTER //
// ./src/lang/bjly.js